import { Maybe, Node } from "../components/graphql/schema.graphql";

// TODO: `interface PageInfo` is duplicated multiple time in the codebase with small different definitions. This involve fixing the backend too.
interface PageInfo {
  endCursor?: Maybe<string>;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor?: Maybe<string>;
  totalCount?: Maybe<number>;
}

type RelayEdge<N extends Node> = {
  node?: Maybe<N>;
  cursor?: Maybe<string>;
};

type RelayConnection<N extends Node> = {
  edges?: Maybe<Maybe<RelayEdge<N>>[]>;
  pageInfo?: PageInfo;
};

const getConnectionEdgesTyped = <N extends Node>(
  connection: RelayConnection<N>,
) => connection?.edges?.filter((e) => e != null) || [];

export const getConnectionNodesTyped = <N extends Node>(
  connection: RelayConnection<N>,
) =>
  getConnectionEdgesTyped(connection)
    .map((e) => e.node)
    .filter((n) => n != null) || [];
